/* eslint-disable default-case */
/* eslint-disable no-lone-blocks */
import React, { useEffect, useState } from 'react'
import { GenericFormSpreadTypeComponent } from '../../../genericComponents/forms/GenericFormSpreadTypeComponent'
import { getFileNameFromUrl, parseJwt } from '../../../helper/genericFunction';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler, handleApiChange } from '../../../helper/apiHelperFunctions';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import ParentModal from '../../../genericComponents/ParentModal';
import AddShipmentAdvice from './AddShipmentAdvice';
import useCustomToast from '../../../hooks/useCustomToast';
import Icons from '../../../assets/icons';
import { validateNumber } from '../../../helper/apiHelperFunctions';
import ManageAddress from '../orders/components/ManageAddress';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import { getCurrentDateFormat, getFileNameFromExt, getFileTypeFromUrl } from '../../../helper/helperTableFunctions';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../helper/permissions';
import { CONFIG } from '../../../config';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import { EyeOff, FileOutput, HandCoins, IndianRupee, Paperclip } from 'lucide-react';
import GenericDeleteModal from '../../../genericComponents/helperComponents/GenericDeleteModal';
import { m } from 'framer-motion';
import GenericMediaViewModal from '../../../genericComponents/media/GenericMediaViewModal';
import TextWithTooltip from '../../../genericComponents/TextWithTooltip';

function CreateLr(props) {

    let getValueByUType = {
        VENDOR: "isMandatoryV",
        ENT: "isMandatoryV"
    }

    const { isEdit, selectedData, modalHeading, vendConfig, prevParams = {} } = props;
    const lrTypeList = {
        topay: "To Pay",
        toBilled: "To Be Billed",
        Paid: "Paid"
    }
    const logisticsAndDeliveryDetailsArray = ["transporterName", "lrType", "otherTransporterName", "lrDate", "lrETADate", "consignmentSlip", "invoiceNumber", "invoiceDate", "address", "invoiceDoc"],
        eWayBillDocArray = ["ewbBillNo", "ewbBillDate", "ewbBillDoc"],
        otherDetails = ["consignmentNo", "courier", "transporterName", "lrWeight", "lrRate", "otherCharges", "lrFreight", "lrPcs", "lrBales", "transporterMode", "vehicleType", "vehicleNo", "declarationAmount", "consigneeName", "consignorName", "stationFrom", "stationTo", "remarks", "consignorCode"];
    const userType = parseJwt(sessionStorage.getItem('token'))?.uType?.toUpperCase() || "ENT";
    // For these clients, disable the auto-filled otherTransporterName field in create flow
    const disableAutoTransporterSchemaIds = ["787", "2398", "1"];
    const currentSchemaEntId = parseJwt(sessionStorage.getItem('token'))?.schemaEntID, hopscotchSchemaEntId = ["8534", "754"];
    const [formData, setFormData] = useState({});
    const [errorData, setErrorData] = useState({});
    const digiVendStore = useSelector(state => state.digivendStore);
    const generalStore = useSelector(state => state.generalStore)
    const [getInputField, setSetInputField] = useState({})
    const dispatch = useDispatch();
    const [uuId, setUuId] = useState("");
    const [callbackFunction, setCallbackFunction] = useState("");
    const [lrDetailList, setLrDetailList] = useState([]);
    const [storeAutoApiRes, setStoreAutoApiRes] = useState({})
    const [openedModal, setOpenedModal] = useState("");
    const [modalData, setModalData] = useState({})
    const [vehicleTypeList, setVehicleTypeList] = useState([])
    const [showRecommendtion, setShowRecommendtion] = useState(true)
    const [courierParDetails, setCourierParDetails] = useState({})
    const [otherTransData, setOtherTransData] = useState("")
    // True only when otherTransporterName was auto-filled from the auto API (create flow, specific clients)
    const [isTransporterAutoFilled, setIsTransporterAutoFilled] = useState(false)
    const customToast = useCustomToast();
    const [otherTransporterCheck, setOtherTransporterCheck] = useState(false)
    const [isLrWeightDisabled, setIsLrWeightDisabled] = useState(false);
    const [uploadedFileDirectory, setUploadedFileDirectory] = useState({});
    const [updateImageState, setUpdateImageState] = useState(false)
    const [ewayBillChecked, setEwayBillChecked] = useState(false)
    const [getAutoApiData, setGetAutoApiData] = useState({})

    // Courrier partner state: to store the courrier partner configuration
    const [COURIER_PARTNER, updateCourierPartner] = useState(vendConfig?.COURIER_PARTNER_CONFIG?.COURIER_PARTNER ? typeof (vendConfig?.COURIER_PARTNER_CONFIG?.COURIER_PARTNER) === "string" ? vendConfig?.COURIER_PARTNER_CONFIG?.COURIER_PARTNER?.toLowerCase() === "true" : vendConfig?.COURIER_PARTNER_CONFIG?.COURIER_PARTNER : false);
    // State: To store the Courier patrner mandatory configuration
    const [MANDATORY, setCourierPartnerMandatory] = useState(vendConfig?.COURIER_PARTNER_CONFIG?.MANDATORY ? typeof (vendConfig?.COURIER_PARTNER_CONFIG?.MANDATORY) === "string" ? vendConfig?.COURIER_PARTNER_CONFIG?.MANDATORY?.toLowerCase() === "true" : vendConfig?.COURIER_PARTNER_CONFIG?.MANDATORY : false)

    const currentDate = dayjs(new Date())

    const [transportModeDropdown, setTransportModeDropdown] = useState([]);
    const [openFilesDropdown, setOpenFilesDropdown] = useState(false);

    useEffect(() => {
        if (callbackFunction === "calculateFright") {
            calculateFright()
        }
        if (callbackFunction === "clearVehicleDet") {
            updateStateInCallBack('otherDetails', { vehicleType: null, vehicleNo: null, consignmentNo: null }, { transporterMode: "" })
        }
        if (callbackFunction == "handleOnChange") {
            if (formData?.otherDetails?.transporterMode?.transporterMode) {
                // Call to update the mandate or non mandate state of the Vechile Number or Type based on mode
                handleOnChange({ key: "transporterMode" }, formData?.otherDetails?.transporterMode)
            }
        }
        setCallbackFunction("")
    }, [callbackFunction]);

    const updateStateInCallBack = (key, obj, extraKey) => {
        let formDataClone = { ...formData }, errorDataClone = { ...errorData };
        Object.keys(obj || {})?.map((item) => {
            formDataClone[key][item] = obj?.[item]
            if (errorDataClone?.[key]?.[item]) {
                delete errorDataClone?.[key]?.[item]
            }
        })
        Object.keys(extraKey || {})?.map((newKey) => {
            if (obj?.[newKey]) {
                formDataClone[key][newKey] = obj?.[newKey]
            }
            if (errorDataClone?.[key]?.[newKey]) {
                delete errorDataClone?.[key]?.[newKey]
            }
        })
        setErrorData(errorDataClone)
        setFormData(formDataClone);
    }

    const permissionsObj = getPermissionKey("purchase", "logistic", isEdit ? "update" : "create");

    useEffect(() => {
        let getInitialFormData = {
            logisticsAndDeliveryDetails: {},
            eWayBillDoc: {},
            otherDetails: {}
        };
        if (isEdit) {
            dispatchHandler(dispatch, "vendorlogiFindLrAutoRequest", { logisticId: selectedData?.logisticId || "", baseUrl: CONFIG.SM_BACKEND_BASE_URL, apiUrl: "/purchase/logistics/data/auto" }, permissionsObj);
        }
        else {
            dispatchHandler(dispatch, "vendorlogiFindLrAutoRequest", { shipmentId: prevParams?.type == "CREATE_SHIPMENT_WITH_LR" ? undefined : selectedData?.shipmentId || "", orderId: prevParams?.type == "CREATE_SHIPMENT_WITH_LR" ?  prevParams?.id || "" : undefined, baseUrl: CONFIG.SM_BACKEND_BASE_URL, apiUrl: "/purchase/logistics/data/auto" }, permissionsObj);
            getInitialFormData.logisticsAndDeliveryDetails.lrDate = currentDate
            if (MANDATORY && COURIER_PARTNER) {
                getInitialFormData.logisticsAndDeliveryDetails.lrType = {
                    "lrType": "topay",
                    "value": "To Pay"
                }
            }
        }
        dispatchHandler(dispatch, "formSettingGetLrRequest", {}, permissionsObj);
        let lrDetailListData = [];
        lrDetailListData.push({ ...selectedData, shipmentAdviceNo: selectedData?.shipmentAdviceCode });
        setLrDetailList(lrDetailListData);
        setFormData(getInitialFormData);
        let tokenData = parseJwt(sessionStorage.getItem("token")) || {};
        setUuId(uuidv4() + (tokenData.jti || ""));

        handleApiChange(dispatch, "getDropdownRequest", { type: 'VEHICLE_TYPE' })
        setTimeout(() => {
            handleApiChange(dispatch, "getDropdownRequest", {
                type: 'LR_TRANSPORT_TYPE'
            })
        }, 1000)
    }, []);

    useEffect(() => {
        if (digiVendStore?.formSettingGetLrData?.isSuccess) {
            let inputField = {
                logisticsAndDeliveryDetails: [],
                eWayBillDoc: [],
                otherDetails: []
            };
            let response = digiVendStore?.formSettingGetLrData?.data?.resource?.data || {};
            const desiredOrder = [
                "lrType", "transporterName", "lrDate", "lrETADate", "consignmentSlip",
                "invoiceNumber", "invoiceDoc", "invoiceDate", "address", "otherTransporterName",
                "ewbBillNo", "ewbBillDate", "ewbBillDoc", "consignmentNo", "courier",
                "lrWeight", "lrRate", "otherCharges", "lrFreight", "lrPcs", "lrBales",
                "transporterMode", "vehicleType", "vehicleNo", "distance", "declarationAmount",
                "consigneeName", "consignorName", "consignorCode", "stationFrom", "stationTo", "remarks",
            ];
            const reorderedObject = Object.fromEntries(
                desiredOrder.map(key => [key, response[key] || ""])
            );
            Object.keys(reorderedObject)?.map((item) => {
                let data = {};
                if (logisticsAndDeliveryDetailsArray.includes(item) && (userType === "VENDOR" ? response[item]?.isDisplayV : response[item]?.isDisplay)) {
                    data = {
                        key: response[item]?.supplymintCKey || item,
                        mandatory: userType === "VENDOR" ? response[item]?.isMandatoryV || "" : response[item]?.isMandatory || "",
                        label: response[item]?.columnName || "",
                        type: response[item]?.inputType === "LOV" ? "dropdown" : response[item]?.inputType?.toLowerCase(),
                        isDisabled: isEdit ? userType === "VENDOR" ? !(response[item]?.isUpdateAllowV) : !(response[item]?.isUpdateAllow) : userType === "VENDOR" ? !(response[item]?.isEditableV) : !(response[item]?.isEditable),
                    }
                    inputField.logisticsAndDeliveryDetails.push(data);
                }
                else if (eWayBillDocArray.includes(item) && (userType === "VENDOR" ? response[item]?.isDisplayV : response[item]?.isDisplay)) {
                    data = {
                        key: response[item]?.supplymintCKey || item,
                        mandatory: userType === "VENDOR" ? response[item]?.isMandatoryV || "" : response[item]?.isMandatory || "",
                        label: response[item]?.columnName || "",
                        type: response[item]?.inputType === "LOV" ? "dropdown" : response[item]?.inputType?.toLowerCase(),
                        isDisabled: isEdit ? userType === "VENDOR" ? !(response[item]?.isUpdateAllowV) : !(response[item]?.isUpdateAllow) : userType === "VENDOR" ? !(response[item]?.isEditableV) : !(response[item]?.isEditable),
                    }
                    inputField.eWayBillDoc.push(data);
                }
                else if (item && (userType === "VENDOR" ? response[item]?.isDisplayV : response[item]?.isDisplay)) {
                    data = {
                        key: response[item]?.supplymintCKey || item,
                        mandatory: userType === "VENDOR" ? response[item]?.isMandatoryV || "" : response[item]?.isMandatory || "",
                        label: response[item]?.columnName || "",
                        type: response[item]?.inputType === "LOV" ? "dropdown" : response[item]?.inputType?.toLowerCase(),
                        isDisabled: isEdit ? userType === "VENDOR" ? !(response[item]?.isUpdateAllowV) : !(response[item]?.isUpdateAllow) : (item == "vehicleType" || item == "consignmentNo" || item == "courier" || item == "vehicleNo") ? true : userType === "VENDOR" ? !(response[item]?.isEditableV) : !(response[item]?.isEditable),
                    }
                    inputField.otherDetails.push(data);
                }
            });
            setSetInputField(inputField);
            setCallbackFunction("handleOnChange")
        }

        if (digiVendStore?.vendorlogiFindLrAutoData?.isSuccess) {
            if(isEdit) {
                let getInitialFormData = {
                    logisticsAndDeliveryDetails: {},
                    eWayBillDoc: {},
                    otherDetails: {}
                }, dateField = ["lrDate", "lrETADate", "invoiceDate", "aptDate", "ewbBillDate"],
                    fileDirectory = { ...uploadedFileDirectory };
                let response = digiVendStore?.vendorlogiFindLrAutoData?.data?.resource || {};
                response && Object.keys(response)?.map((key) => {
                    if (logisticsAndDeliveryDetailsArray.includes(key)) {
                        getInitialFormData.logisticsAndDeliveryDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                    }
                    else if (eWayBillDocArray.includes(key)) {
                        getInitialFormData.eWayBillDoc[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                    }
                    else if (otherDetails.includes(key)) {
                        getInitialFormData.otherDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] != undefined && response?.[key] != null ? `${response?.[key]}` : ""
                    }
                })
                if (response?.hasOwnProperty('distance')) {
                    setEwayBillChecked(response?.distance)
                }
                if (response?.["transporterMode"]) {
                    getInitialFormData.otherDetails.transporterMode = { "transporterMode": response?.["transporterMode"] };
                }
                // Update the vechile number and vechle type data here -> 
                if (response?.["vehicleType"]) {
                    getInitialFormData.otherDetails.vehicleType = { "vehicleType": response?.["vehicleType"] };
                }
                // Update the vechile details end here
                if (response?.lrType) {
                    getInitialFormData.logisticsAndDeliveryDetails.lrType = {
                        lrType: response?.lrType === "toPay" ? "topay" : response?.lrType,
                        value: response?.lrType === "toPay" ? "To Pay" : lrTypeList[response?.lrType]
                    }
                }
                if (response?.vaAddress) {
                    getInitialFormData.logisticsAndDeliveryDetails.address = { address: response?.vaAddress }
                }
                getInitialFormData.logisticsAndDeliveryDetails.transporterName = response?.lrNo
                getInitialFormData.logisticsAndDeliveryDetails.consignmentSlip = []
                if(hopscotchSchemaEntId?.includes(currentSchemaEntId) && response?.invoiceApprovedBy) {
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceDoc = response?.invoiceDocUrl ? [response?.invoiceDocUrl] : []
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceApprovedBy = response?.invoiceApprovedBy ?? ""
                }
                else {
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceDoc = (userType == "VENDOR" && hopscotchSchemaEntId?.includes(currentSchemaEntId) && response?.invoiceApprovedBy) ? response?.invoiceDocUrl ? [response?.invoiceDocUrl] : [] :  [];
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceApprovedBy = false
                }
                getInitialFormData.eWayBillDoc["ewbBillDoc"] = []
                getInitialFormData.logisticsAndDeliveryDetails.otherTransporterName = {
                    transporterName: response?.transporterName,
                    transporterCode: response?.transporterCode
                }
                fileDirectory["ewbBillDoc"] = response?.ewbBillDoc || ""
                fileDirectory["consignmentSlip"] = response?.consignmentSlip || "";

                setUploadedFileDirectory(fileDirectory);
                setFormData(getInitialFormData);
                setStoreAutoApiRes(response);
            }
            else {
                let getInitialFormData = {
                    logisticsAndDeliveryDetails: { ...formData?.logisticsAndDeliveryDetails },
                    eWayBillDoc: { ...formData?.eWayBillDoc },
                    otherDetails: { ...formData?.otherDetails }
                }, dateField = ["lrDate", "lrETADate", "invoiceDate", "aptDate", "ewbBillDate"],
                fileDirectory = { ...uploadedFileDirectory };
                let response = digiVendStore?.vendorlogiFindLrAutoData?.data?.resource || {};
                let dataKeyObj = { consignee: "consigneeName", consignor: "consignorName", fromLocation: "stationFrom", toLocation: "stationTo", lrBales: "lrBales", declarationAmount: "declarationAmount", transporter: "otherTransporterName", boxWeight: "lrWeight" };
                response && Object.keys(response)?.map((key) => {
                    if (logisticsAndDeliveryDetailsArray.includes(key) && !["address"]?.includes(key)) {
                        getInitialFormData.logisticsAndDeliveryDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || "";
                    }
                    else if (eWayBillDocArray.includes(key)) {
                        getInitialFormData.eWayBillDoc[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                    }
                    else if (otherDetails.includes(key)) {
                        getInitialFormData.otherDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                    }
                })
                getInitialFormData.logisticsAndDeliveryDetails.lrDate = currentDate
                // getInitialFormData.otherDetails.lrPcs = response?.totalRequestedQty
                // getInitialFormData.otherDetails.lrBales = response?.unitCount || 0
                if (response?.transporterName && response?.transporterCode) {
                    getInitialFormData.logisticsAndDeliveryDetails.otherTransporterName = {
                        transporterName: response?.transporterName,
                        transporterCode: response?.transporterCode
                    }
                    setIsTransporterAutoFilled(true)
                }
                else {
                    getInitialFormData.logisticsAndDeliveryDetails.otherTransporterName = null
                    setIsTransporterAutoFilled(false)
                }
                getInitialFormData.logisticsAndDeliveryDetails.transporterName = response?.lrNo || ""
                if (MANDATORY && COURIER_PARTNER) {
                    getInitialFormData.logisticsAndDeliveryDetails.lrType = {
                        "lrType": "topay",
                        "value": "To Pay"
                    }
                }
                if(hopscotchSchemaEntId?.includes(currentSchemaEntId) && response?.invoiceApprovedBy) {
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceDoc = response?.invoiceDocUrl ? [response?.invoiceDocUrl] : []
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceApprovedBy = response?.invoiceApprovedBy ?? ""
                }
                else {
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceDoc = (userType == "VENDOR" && hopscotchSchemaEntId?.includes(currentSchemaEntId) && response?.invoiceApprovedBy) ? response?.invoiceDocUrl ? [response?.invoiceDocUrl] : [] :  [];
                    getInitialFormData.logisticsAndDeliveryDetails.invoiceApprovedBy = false
                }
                fileDirectory["ewbBillDoc"] = response?.ewbBillDoc || ""
                fileDirectory["consignmentSlip"] = response?.consignmentSlip || ""
                fileDirectory["invoiceDoc"] = response?.invoiceDoc || ""
                setUploadedFileDirectory(fileDirectory);
                let lrWeightdis = typeof response?.weightDisable == "string" ? response?.weightDisable?.toLowerCase() == "true" ? true : false : response?.weightDisable;
                setIsLrWeightDisabled(lrWeightdis);
                setOtherTransData(response?.transporter?.transporterName);
                setStoreAutoApiRes(response);
                setFormData(getInitialFormData);
            }
        }

        if (digiVendStore?.vendorlogiFindLrAutoData?.isSuccess && isEdit) {
            let response = digiVendStore?.vendorlogiFindLrAutoData?.data?.resource

            setUploadedFileDirectory(prevValue => ({
                ...prevValue,
                invoiceDoc: response?.invoiceDoc || ""
            }))
        }

        if (digiVendStore?.vendorlogiLrGetRateData?.isSuccess) {
            let formDataClone = { ...formData };
            formDataClone.otherDetails.lrRate = digiVendStore?.vendorlogiLrGetRateData?.data?.resource?.rate || 0
            setFormData(formDataClone);
            // Remove the error inside the rate field, if present in error data
            let updatedErrorState = { ...errorData };
            if (updatedErrorState?.["otherDetails"]?.["lrRate"]) {
                delete updatedErrorState?.["otherDetails"]?.["lrRate"];
                setErrorData(updatedErrorState);
            }
            setCallbackFunction("calculateFright");
        }

        if (digiVendStore?.updateLogisticsData?.isSuccess || digiVendStore?.vendorlogiLrCreateData?.isSuccess) {
            props?.closeModal();
        }

        if (generalStore?.getDropdownData?.isSuccess) {
            if (generalStore?.getDropdownData?.data?.resource) {
                switch(generalStore?.getDropdownData?.data?.type){
                    case "LR_TRANSPORT_TYPE" : {
                        setTransportModeDropdown(generalStore?.getDropdownData?.data?.resource);
                        break;
                    }
                    default : {
                        let vehicleType = [];
                        vehicleType = generalStore?.getDropdownData?.data?.resource.map((item) => {
                            return { vehicleType: item }
                        })
                        setVehicleTypeList(vehicleType);
                        break;
                    }
                }
            }
        }

        // Recommend Now Api Successs Handler
        if (digiVendStore?.vendorlogiRecommendationData?.isSuccess) {
            let getInitialFormData = {
                logisticsAndDeliveryDetails: { ...formData?.logisticsAndDeliveryDetails },
                eWayBillDoc: { ...formData?.eWayBillDoc },
                otherDetails: { ...formData?.otherDetails }
            };
            let response = digiVendStore?.vendorlogiRecommendationData?.data?.resource
            if (response?.transporterCode && response?.transporterName) {
                getInitialFormData.logisticsAndDeliveryDetails.otherTransporterName = {
                    transporterCode: response?.transporterCode || "",
                    transporterName: response?.transporterName || ""
                }
            }
            else getInitialFormData.logisticsAndDeliveryDetails.otherTransporterName = null
            getInitialFormData.logisticsAndDeliveryDetails.transporterName = ""
            getInitialFormData.logisticsAndDeliveryDetails.lrType = {
                "lrType": "topay",
                "value": "To Pay"
            }
            getInitialFormData.otherDetails.lrRate = response?.shippingCharge || 0
            setCourierParDetails(response);
            setShowRecommendtion(true);
            // In the case where user recommendation api get success the usages of COURIER_PARTNER will be void, we will set them default as true;
            setCourierPartnerMandatory(true);
            updateCourierPartner(true);
            // As the lrRate has been updated by shipping charges by recomendations api, the freight will also get calculated
            setCallbackFunction("calculateFright");

            setFormData(getInitialFormData);

            //Remove all error in this case whent the data gets filled by the api.
            setErrorData({});
        }
        else if (digiVendStore?.vendorlogiRecommendationData?.isError) {
            // Recommend Now Api Error Handler
            let buttonDisableMessage = "Box details are not available for this LR (Shipment). Please proceed without courier recommendation"
            if (digiVendStore?.vendorlogiRecommendationData?.message?.errorMessage == buttonDisableMessage) {
                // In the case where user recommendation api get error and gives specific above message  the usages of COURIER_PARTNER will be mandatory, we will set them default as false;
                setCourierPartnerMandatory(false);
                updateCourierPartner(false);

                setShowRecommendtion(false);
            }
        }

    }, [digiVendStore?.formSettingGetLrData?.isSuccess, digiVendStore?.vendorlogiFindLrAutoData?.isSuccess, digiVendStore?.vendorlogiLrGetRateData?.isSuccess, digiVendStore?.updateLogisticsData?.isSuccess, digiVendStore?.vendorlogiLrCreateData?.isSuccess, generalStore?.getDropdownData?.isSuccess, digiVendStore?.vendorlogiRecommendationData?.isSuccess, digiVendStore?.vendorlogiRecommendationData?.isError])

    const handleChange = (type, data) => {
        switch (type) {
            case "finalSubmit": {
                if (isEdit) {
                    let payload = {
                        apiUrl: userType === "VENDOR" ? "/vendorportal/vendorlogi/update/logistics" : "/vendorportal/entlogi/update/logistics",
                        id: storeAutoApiRes?.id,
                        permitNo: storeAutoApiRes?.permitNo,
                        policyNo: storeAutoApiRes?.policyNo,
                        lrETADate: formData?.logisticsAndDeliveryDetails?.lrETADate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrETADate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        lrDate: formData?.logisticsAndDeliveryDetails?.lrDate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        transporterCode: formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterCode || "",
                        transporterName: formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterName || "",
                        logisticNo: storeAutoApiRes?.logisticNo,
                        lrNo: formData?.logisticsAndDeliveryDetails?.transporterName || "",
                        lrWeight: formData?.otherDetails?.lrWeight?.toString() || "",
                        lrType: formData?.logisticsAndDeliveryDetails?.lrType?.lrType || "",
                        lrRate: formData?.otherDetails?.lrRate?.toString() || "",
                        lrFreight: formData?.otherDetails?.lrFreight?.toString() || "",
                        ewbBillNo: formData?.eWayBillDoc?.ewbBillNo || "",
                        ewbBillDate: formData?.eWayBillDoc?.ewbBillDate ? dayjs(formData?.eWayBillDoc?.ewbBillDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        ewbBillDoc: uploadedFileDirectory?.ewbBillDoc || "",
                        otherCharges: formData?.otherDetails?.otherCharges?.toString() || "",
                        declarationAmount: formData?.otherDetails?.declarationAmount?.toString() || "",
                        remarks: formData?.otherDetails?.remarks || "",
                        consignmentSlip: uploadedFileDirectory?.consignmentSlip || "",
                        invoiceDoc: uploadedFileDirectory?.invoiceDoc || "",
                        vehicleNo: formData?.otherDetails?.vehicleNo || "",
                        vehicleType: formData?.otherDetails?.vehicleType?.vehicleType || "",
                        transporterMode: formData?.otherDetails?.transporterMode?.transporterMode || "",
                        invoiceDate: formData?.logisticsAndDeliveryDetails?.invoiceDate ? dayjs(formData?.logisticsAndDeliveryDetails?.invoiceDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        invoiceNumber: formData?.logisticsAndDeliveryDetails?.invoiceNumber || "",
                        uuid: uuId,
                        distance: ewayBillChecked,

                        // Matching Create Lr Payload Filling Missing Keys from create lr

                        lrPcs: formData?.otherDetails?.lrPcs || "",
                        lrBales: formData?.otherDetails?.lrBales || "",
                        consignmentNo: formData?.otherDetails?.consignmentNo || "",
                        consigneeName: formData?.otherDetails?.consigneeName || "",
                        consignorName: formData?.otherDetails?.consignorName || "",
                        consignorCode: formData?.otherDetails?.consignorCode || "",
                        stationFrom: formData?.otherDetails?.stationFrom || "",
                        stationTo: formData?.otherDetails?.stationTo || "",
                    }
                    if (MANDATORY && showRecommendtion) {
                        payload.accountCode = courierParDetails?.accountCode
                        payload.accountId = courierParDetails?.accountId?.toString()
                        payload.logisticDraftNo = storeAutoApiRes?.lrNo
                        payload.cpId = courierParDetails?.cpId
                    }
                    dispatchHandler(dispatch, "updateLogisticsRequest", payload, permissionsObj);
                }
                else {
                    let lrDetailListData = [...lrDetailList]
                    let lrDetailPayload = []
                    for (let i = 0; i < lrDetailListData.length; i++) {
                        let data = {
                            saId: lrDetailListData[i].id,
                            saTotalQty: lrDetailListData[i].totalRequestedQty,
                            saTotalAmount: lrDetailListData[i].basicAmount,
                            dueDays: lrDetailListData[i].dueDays,
                            remarks: lrDetailListData[i].remarks,
                            shipmentAdviceNo: lrDetailListData[i].shipmentAdviceNo,
                            orderDate: lrDetailListData?.[i]?.poDate 
                            ? dayjs(
                                lrDetailListData?.[i]?.poDate, 
                                getCurrentDateFormat(lrDetailListData?.[i]?.poDate)
                            ).format("YYYY-MM-DDT00:00:00+05:30") 
                            : "",
                            validFromDate: lrDetailListData?.[i]?.validFromDate 
                            ? dayjs(
                                lrDetailListData?.[i]?.validFromDate, 
                                getCurrentDateFormat(lrDetailListData?.[i]?.validFromDate)
                            ).format("YYYY-MM-DDT00:00:00+05:30") 
                            : "",
                            validToDate: lrDetailListData?.[i]?.validToDate 
                            ? dayjs(
                                lrDetailListData?.[i]?.validToDate, 
                                getCurrentDateFormat(lrDetailListData?.[i]?.validToDate)
                            ).format("YYYY-MM-DDT00:00:00+05:30") 
                            : "",
                            shipmentAdviceDate: lrDetailListData?.[i]?.shipmentSelectionDate 
                            ? dayjs(
                                lrDetailListData?.[i]?.shipmentSelectionDate, 
                                getCurrentDateFormat(lrDetailListData?.[i]?.shipmentSelectionDate)
                            ).format("YYYY-MM-DDT00:00:00+05:30") 
                            : "",
                            orderCode: lrDetailListData[i].orderCode,
                            orderNo: lrDetailListData[i].orderNumber,
                            orderId: lrDetailListData[i].orderId,
                            documentNumber: lrDetailListData[i].documentNumber,
                            poType: lrDetailListData[i].poType,
                        }
                        lrDetailPayload.push(data)
                    }
                    let payload = {
                        ewbBillNo: formData?.eWayBillDoc?.ewbBillNo || "",
                        ewbBillDate: formData?.eWayBillDoc?.ewbBillDate ? dayjs(formData?.eWayBillDoc?.ewbBillDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        ewbBillDoc: uploadedFileDirectory?.ewbBillDoc || "",
                        logisticDate: dayjs(currentDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30",
                        lrNo: formData?.logisticsAndDeliveryDetails?.transporterName || "",
                        lrDate: formData?.logisticsAndDeliveryDetails?.lrDate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        transporterCode: otherTransporterCheck ? vendConfig?.visibleKeys?.CUSTOM_TRANSPORTER?.split("|")?.[0] : formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterCode || "",
                        transporterName: otherTransporterCheck ? vendConfig?.visibleKeys?.CUSTOM_TRANSPORTER?.split("|")?.[1] : formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterName || "",
                        otherTransporterName: otherTransporterCheck ? formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterName : null,
                        lrPcs: formData?.otherDetails?.lrPcs || "",
                        lrBales: formData?.otherDetails?.lrBales || "",
                        lrWeight: formData?.otherDetails?.lrWeight || "",
                        lrType: formData?.logisticsAndDeliveryDetails?.lrType?.lrType || "",
                        lrRate: formData?.otherDetails?.lrRate || "",
                        lrFreight: formData?.otherDetails?.lrFreight?.toString() || "",
                        permitNo: storeAutoApiRes?.permitNo || "",
                        policyNo: storeAutoApiRes?.policyNo || "",
                        declarationAmount: formData?.otherDetails?.declarationAmount || "",
                        consignorName: formData?.otherDetails?.consignorName || "",
                        consignorCode: formData?.otherDetails?.consignorCode || "",
                        consigneeName: formData?.otherDetails?.consigneeName || "",
                        stationFrom: formData?.otherDetails?.stationFrom || "",
                        stationTo: formData?.otherDetails?.stationTo || "",
                        vehicleNo: formData?.otherDetails?.vehicleNo || "",
                        vehicleType: formData?.otherDetails?.vehicleType?.vehicleType || "",
                        remarks: formData?.otherDetails?.remarks || "",
                        transporterMode: formData?.otherDetails?.transporterMode?.transporterMode || "",
                        lrDetailList: lrDetailPayload,
                        courier: formData?.otherDetails?.courier || "",
                        consignmentNo: formData?.otherDetails?.consignmentNo || "",
                        ownerSite: formData?.otherDetails?.stationTo || "",
                        lrETADate: formData?.logisticsAndDeliveryDetails?.lrETADate ? dayjs(formData?.logisticsAndDeliveryDetails?.lrETADate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        vaShortName: formData?.logisticsAndDeliveryDetails?.address?.shortName || "",
                        vaAddress: formData?.logisticsAndDeliveryDetails?.address?.address || "",
                        vaCity: formData?.logisticsAndDeliveryDetails?.address?.city || "",
                        vaState: formData?.logisticsAndDeliveryDetails?.address?.state || "",
                        vaAddressLine1: formData?.logisticsAndDeliveryDetails?.address?.addressLine1 || "",
                        vaZipCode: formData?.logisticsAndDeliveryDetails?.address?.zipCode || "",
                        vaContactPerson: formData?.logisticsAndDeliveryDetails?.address?.contactPerson || "",
                        vaContactNumber: formData?.logisticsAndDeliveryDetails?.address?.contactNumber || "",
                        vaEmail: formData?.logisticsAndDeliveryDetails?.address?.email || "",
                        consignmentSlip: uploadedFileDirectory?.consignmentSlip || "",
                        invoiceDoc: uploadedFileDirectory?.invoiceDoc || "",
                        agentCode: storeAutoApiRes?.agentCode || "",
                        agentName: storeAutoApiRes?.agentName || "",
                        otherCharges: formData?.otherDetails?.otherCharges?.toString() || "",
                        invoiceDate: formData?.logisticsAndDeliveryDetails?.invoiceDate ? dayjs(formData?.logisticsAndDeliveryDetails?.invoiceDate)?.format("YYYY-MM-DD") : "",
                        invoiceNumber: formData?.logisticsAndDeliveryDetails?.invoiceNumber || "",
                        uuid: uuId,
                        distance: ewayBillChecked
                    }
                    if (MANDATORY && showRecommendtion) {
                        payload.accountCode = courierParDetails?.accountCode
                        payload.accountId = courierParDetails?.accountId?.toString()
                        payload.logisticDraftNo = storeAutoApiRes?.logisticDraftNo
                        payload.cpId = courierParDetails?.cpId
                    }
                    if(prevParams?.type == "CREATE_SHIPMENT_WITH_LR") {
                        delete payload?.uuid;
                        props?.handleInputChange?.("submitASNLR", payload)
                    }
                    else dispatchHandler(dispatch, "vendorlogiLrCreateRequest", payload, permissionsObj);
                }
            }
                break;
            case "addAsn": {
                setOpenedModal("addAsn");
                break;
            }
            case "clearFormDataConfirm" : {
                if(Object.keys(formData || {})?.length > 0) {
                    setModalData([data])
                    setOpenedModal('confirmModal');
                } else {
                    props?.refreshModal();
                    props?.handleInputChange("createLrRequestFromLR", [data])
                }
                break;
            }
            case "clearFormData" : {
                    setOpenedModal(null)
                    props?.refreshModal();
                    props?.handleInputChange("createLrRequestFromLR", modalData)
                    break;
            }
            case "openImageViewModal" : {
                setOpenedModal('openImageViewModal');
                setModalData(data)
                break;
            }
            default: {
                setOpenedModal(type);
            }
        }
    }

    const validationsCheck = (type, val) => {
        switch (type) {
            case "declarationAmount": return val ? !/^(\d+\.?\d*|\.\d+)$/ ? ["Please enter a valid number"] : null : null
            case "lrWeight": return val ? !/^\d+(\.\d{1,2})?$/ ? ["Please enter a valid weight"] : null : null
            case "vehicleNo": {
                if (val && !(/^[A-Za-z0-9]{6,15}$/.test(val))) {
                    return ["Please enter a valid vehicle No"]
                }
            }
                break;
            default: break
        }
    }

    const handleTranporterName = (value) => {
        let formDataClone = { ...formData }, errorDataClone = { ...errorData };
        if (value) {
            delete formDataClone?.logisticsAndDeliveryDetails?.otherTransporterName
        }
        else {
            formDataClone.logisticsAndDeliveryDetails.otherTransporterName = { transporterName: otherTransData || "" }
            if (delete errorDataClone?.["logisticsAndDeliveryDetails"]?.["otherTransporterName"]) {
                delete errorDataClone?.["logisticsAndDeliveryDetails"]?.["otherTransporterName"]
                setErrorData(errorDataClone)
            }
        }
        setOtherTransporterCheck(value);
        setFormData(formDataClone);
    }

    // Function : To render the custom label of the input fields
    const renderCustomLabel = (config) => {
        let { key } = config;
        switch (key) {
            case "address": {
                return (
                    <>
                        <GenericCustomButton
                            className="manage-address-btn"
                            leftIcon={<Icons.EditIcon />}
                            onClick={() => handleChange("manageAddress")}
                        />
                    </>
                )
            }
        }
    }

    const [getImagesOf, setGetImagesOf] = useState("")

    useEffect(() => {
        if (generalStore?.getDocumentDownloadFilepathData?.isSuccess) {
            let formDataClone = { ...formData };
            if (getImagesOf == "consignmentSlip") {
                formDataClone = {
                    ...formDataClone,
                    logisticsAndDeliveryDetails: {
                        ...formDataClone?.logisticsAndDeliveryDetails,
                        consignmentSlip: generalStore?.getDocumentDownloadFilepathData?.data
                    }
                }
            }
            else if (getImagesOf == "ewbBillDoc") {
                formDataClone = {
                    ...formDataClone,
                    eWayBillDoc: {
                        ...formDataClone?.eWayBillDoc,
                        ewbBillDoc: generalStore?.getDocumentDownloadFilepathData?.data
                    }
                }
            }
            else if (getImagesOf == "invoiceDoc") {
                formDataClone = {
                    ...formDataClone,
                    logisticsAndDeliveryDetails: {
                        ...formDataClone?.logisticsAndDeliveryDetails,
                        invoiceDoc: generalStore?.getDocumentDownloadFilepathData?.data
                    }
                }
            }
            setFormData(formDataClone);
            setUpdateImageState(!updateImageState);
            setGetImagesOf("")
        }
    }, [generalStore?.getDocumentDownloadFilepathData?.isSuccess])

    const clearUploadFiles = (key) => {
        let formDataClone = JSON.parse(JSON.stringify(formData)), fileDirectory = { ...uploadedFileDirectory };
        switch (key) {
            case "consignmentSlip": {
                formDataClone = {
                    ...formDataClone,
                    logisticsAndDeliveryDetails: {
                        ...formDataClone?.logisticsAndDeliveryDetails,
                        consignmentSlip: null
                    }
                }
            }
                break;
            case "ewbBillDoc": {
                formDataClone = {
                    ...formDataClone,
                    eWayBillDoc: {
                        ...formDataClone?.eWayBillDoc,
                        ewbBillDoc: null
                    }
                }
            }
                break;
            case "invoiceDoc": {
                formDataClone = {
                    ...formDataClone,
                    logisticsAndDeliveryDetails: {
                        ...formDataClone?.logisticsAndDeliveryDetails,
                        invoiceDoc: null
                    }
                }
            }
                break;
        }
        delete fileDirectory?.[key]
        setUploadedFileDirectory(fileDirectory)
        setFormData(formData)
    }

    const callApiToGetImages = (key) => {
        let fileDir = uploadedFileDirectory?.[key];
        setGetImagesOf(key)
        switch (key) {
            case "consignmentSlip": {
                if (fileDir && formData?.logisticsAndDeliveryDetails?.consignmentSlip?.length == 0) {
                    let payload = {
                        disposition: "FALSE",
                        fileDirectory: fileDir,
                    }
                    dispatchHandler(dispatch, "getDocumentDownloadFilepathRequest", payload, permissionsObj);
                }
            }
                break;
            case "ewbBillDoc": {
                if (fileDir && formData?.eWayBillDoc?.ewbBillDoc?.length == 0) {
                    let payload = {
                        disposition: "FALSE",
                        fileDirectory: fileDir,
                    }
                    dispatchHandler(dispatch, "getDocumentDownloadFilepathRequest", payload, permissionsObj);
                }
            }
                break;
            case "invoiceDoc": {
                if (fileDir && formData?.logisticsAndDeliveryDetails?.invoiceDoc?.length == 0) {
                    let payload = {
                        disposition: "FALSE",
                        fileDirectory: fileDir,
                    }
                    dispatchHandler(dispatch, "getDocumentDownloadFilepathRequest", payload, permissionsObj);
                }
            }
        }
    }

    const getInputFields = (type) => {
        switch (type) {
            case "checkData": return
            default: {
                let inputFields = [];
                const filteredItems = getInputField?.[type]?.filter(item => item?.key !== 'distance');

                filteredItems?.map((item) => {
                    let obj = {};
                    obj = {
                        key: item?.key,
                        label: item?.label,
                        type: item?.type === "number" ? "decimal" : item?.type,
                        isDisabled: item?.isDisabled,
                        mandatory: item?.mandatory,
                        value: formData?.[type]?.[item.key] == 0 ? "0" : formData?.[type]?.[item.key] || "",
                        validationFunction: (val) => validationsCheck(item?.key, val),
                        iconRight: item?.type == "dropdown" ? <Icons.GlobalSearchIcon /> : null,
                    }
                    if (item?.key == "ewbBillNo" || item?.key == "ewbBillDate" || item?.key == "ewbBillDoc") {
                        if (ewayBillChecked) {
                            obj.mandatory = false
                            delete errorData?.eWayBillDoc
                        }
                        else if (!ewayBillChecked && formData?.otherDetails?.declarationAmount <= 50000) {
                            obj.mandatory = false
                            delete errorData?.eWayBillDoc
                        }

                    }
                    if (item?.key === "lrType") {
                        obj.customInputValue = () => { return lrTypeList?.[formData?.[type]?.[item.key]?.lrType] || "" }
                        if ((MANDATORY && COURIER_PARTNER) || Object?.keys(courierParDetails || {})?.length > 0) {
                            obj.isDisabled = true
                        }
                    }
                    if (item?.key === "otherTransporterName") {
                        // For specific clients, disable the field in the create flow only when it was auto-filled from the auto API (not on manual selection)
                        const isAutoFilledTransporter = !isEdit && disableAutoTransporterSchemaIds.includes(currentSchemaEntId) && isTransporterAutoFilled;
                        let isTransporterDisabled = item?.isDisabled || (MANDATORY && COURIER_PARTNER) || isAutoFilledTransporter;
                        obj.customInputValue = (data) => { return otherTransporterCheck ? data : data?.transporterName || "" }
                        obj.inputComponents = {
                            inputExtra: () => {
                                return (
                                    vendConfig?.visibleKeys?.CUSTOM_TRANSPORTER ?
                                        <label className="generic-checkbox" >
                                            <input type="checkBox" disabled={isTransporterDisabled} checked={otherTransporterCheck} onChange={() => handleTranporterName(!otherTransporterCheck)} />
                                            <span style={{ cursor: isTransporterDisabled ? "not-allowed" : "auto" }} className={`checkmark1 ${isTransporterDisabled && "checkmark1-disabled"}`}></span>
                                            {!isTransporterDisabled && <span className='generic-tooltip'>Other Transporter</span>}
                                        </label> :
                                        null
                                )
                            }
                        }
                        // If the check for the other transporter is enabled
                        if (otherTransporterCheck) {
                            obj.isDisabled = (MANDATORY && COURIER_PARTNER) || isAutoFilledTransporter;
                            obj.type = "text";
                        }
                        else if (COURIER_PARTNER && MANDATORY) {
                            obj.isDisabled = true;
                        } else {
                            obj.isDisabled = item?.isDisabled || isAutoFilledTransporter
                            obj.type = otherTransporterCheck ? "text" : obj?.type;
                        }
                    }
                    if (item?.key === "transporterName") {
                        if ((MANDATORY && COURIER_PARTNER) || Object?.keys(courierParDetails || {})?.length > 0) {
                            obj.isDisabled = true
                        }
                    }
                    if (item?.type == "dropdown" || item.type == "upload") {
                        obj["inputProps"] = () => getInputProps(item?.key)
                    }
                    if (item.type == "upload") {
                        obj["mandatory"] = uploadedFileDirectory?.[item?.key] ? false : obj?.mandatory
                        obj["labelRightComponent"] = (uploadedFileDirectory?.[item?.key] && item?.mandatory) ? () => {
                            return (<span className="mandatory">*</span>)
                        } : null
                        obj["clearPressFunction"] = () => clearUploadFiles(item?.key)
                        obj["callApiToGetImages"] = () => callApiToGetImages(item?.key)
                        obj["customInputValue"] = () => `${(uploadedFileDirectory?.[item?.key] && formData?.[type]?.[item?.key]?.length == 0) ? "Edit Files" : (formData?.[type]?.[item?.key]?.length == 0 || !formData?.[type]?.[item?.key]) ? "Attach File" : `${formData?.[type]?.[item?.key]?.length} ${formData?.[type]?.[item?.key]?.length <= 1 || !formData?.[type]?.[item?.key] ? "File" : "Files"}`}`
                        if(hopscotchSchemaEntId?.includes(currentSchemaEntId) && item?.isDisabled && userType == "VENDOR" && (!formData?.logisticsAndDeliveryDetails?.invoiceApprovedBy && item?.key == "invoiceDoc")) {
                            // these changes done as per saras what says
                            obj.isDisabled = false
                        } else if (formData?.[type]?.[item?.key]?.length > 0 && hopscotchSchemaEntId?.includes(currentSchemaEntId) && item?.key == "invoiceDoc" && item?.isDisabled) {
                            obj["renderCutomInput"] = () =>
                                <div className='relative' tabIndex={0} onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setOpenFilesDropdown(false)
                                    }
                                }}>
                                    <div className='p-[5px] h-[32px] w-full rounded-[3px] border border-borderSlateGrey flex items-center justify-between gap-4 focus:border-primary cursor-pointer' onClick={() => setOpenFilesDropdown(!openFilesDropdown)}>
                                        <span className='text-xs font-semibold text-[#23235f]'>
                                            {formData?.[type]?.[item?.key]?.length} {formData?.[type]?.[item?.key]?.length <= 1 || !formData?.[type]?.[item?.key] ? "File" : "Files"}
                                        </span>
                                        <Icons.DownArrowNew />
                                    </div>
                                    <div className={`p-[12px] w-full space-y-3 bg-white absolute z-[1] mt-[4px] shadow-lg border border-borderSlateGrey rounded-[3px] duration-200 ${openFilesDropdown ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-1 invisible'}`}>
                                        {formData?.[type]?.[item?.key]?.map((file, index) => {
                                            return (
                                                <div key={index} className='flex items-center gap-2'>
                                                    <Paperclip size={14} className='shrink-0'/>
                                                    <TextWithTooltip
                                                        as='span'
                                                        width={'100%'} 
                                                        text={getFileNameFromUrl(file) || ''} 
                                                        href={file}
                                                        target='_blank' 
                                                        rel="noopener noreferrer"   
                                                        className='text-[11px] font-medium text-[#23235f] cursor-pointer hover:text-[#5d5fef]'
                                                        onClick={e=>{
                                                            e.stopPropagation()
                                                            handleChange('openImageViewModal', file)
                                                        }}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                            </div>                              
                        }
                    }
                    if (item.type == "date") {
                        obj["disabledDate"] = (date) => disabledDate(item.key, date)
                    }
                    if (item.key == "lrWeight" || item.key == "lrRate" || item.key == "otherCharges" || item.key === "otherTransporterName") {
                        obj["onBlur"] = (data) => handleBlurFun(item.key, data)
                        if (item.key == "lrWeight") {
                            obj.isDisabled = isLrWeightDisabled
                        }
                    }
                    if((hopscotchSchemaEntId?.includes(currentSchemaEntId) && item?.isDisabled && userType == "VENDOR" && !formData?.logisticsAndDeliveryDetails?.invoiceApprovedBy) && (item?.key == "invoiceNumber" || item?.key == "invoiceDate")) {
                        // these changes done as per saras what says
                        obj.isDisabled = false
                    }
                    if (item.key === "transporterMode" || item.key === "otherTransporterName") {
                        obj["onChange"] = (data, prevValue) => handleOnChange(item, data, prevValue)
                    }
                    if (item?.key == "lrRate") {
                        obj["avoidMandatoryCheck"] = true;
                        obj["validationFunction"] = (val) => {
                            // Handle the case of lr rate when lr rate value is 0, it will be used as a defined value, not an invalid value.
                            let errors = [];
                            if (obj?.mandatory && (val == undefined || val == null || !(`${val}`))) {
                                errors.push(`${item?.label} is a mandatory field, it cannot be empty, please fill a valid value inside this field!`);
                            } else if (item?.type === "number" && val) {
                                let numberValidationError = validateNumber(val, "decimal", "decimal") || [];
                                errors = [...errors, ...numberValidationError]
                            }
                            return errors;
                        }
                    }
                    if (item?.key == "address") {
                        //  In case of address add the label right component
                        obj.genInputExtraClass = obj?.value?.address?.length > 127 ? 'address-dropdown-input' : null;
                        obj.labelRightComponent = () => renderCustomLabel({ key: "address" });
                    }
                    inputFields.push(obj);
                })
                return inputFields;
            }
        }
    }

    const handleOnChange = (item, val, prevValue) => {
        switch (item.key) {
            case "transporterMode": {
                let getInputFieldClone = JSON.parse(JSON.stringify(getInputField))
                let currentSelectedArray = [...(getInputFieldClone?.otherDetails || [])];
                let vehTypeIndex = currentSelectedArray.findIndex(obj => obj.key === "vehicleType"),
                    consignmentIndex = currentSelectedArray.findIndex(obj => obj.key === "consignmentNo"),
                    vehicleNoIndex = currentSelectedArray.findIndex(obj => obj.key === "vehicleNo"),
                    courierIndex = currentSelectedArray.findIndex(obj => obj.key === "courier"),
                    response = digiVendStore?.formSettingGetLrData?.data?.resource?.data;
                const roadMode = val?.transporterMode === "Road";
                if (vehTypeIndex !== -1) {
                    currentSelectedArray[vehTypeIndex].mandatory = roadMode ? response?.vehicleType?.[getValueByUType?.[userType]] || false : false
                    currentSelectedArray[vehTypeIndex].isDisabled = !roadMode
                }
                if (consignmentIndex !== -1) {
                    currentSelectedArray[consignmentIndex].mandatory = !roadMode ? response?.consignmentNo?.[getValueByUType?.[userType]] || false : false
                    currentSelectedArray[consignmentIndex].isDisabled = roadMode
                }
                if (vehicleNoIndex !== -1) {
                    currentSelectedArray[vehicleNoIndex].mandatory = roadMode ? response?.vehicleNo?.[getValueByUType?.[userType]] || false : false
                    currentSelectedArray[vehicleNoIndex].isDisabled = !roadMode
                }
                if (courierIndex !== -1) {
                    currentSelectedArray[courierIndex].mandatory = !roadMode ? response?.courier?.[getValueByUType?.[userType]] || false : false
                    currentSelectedArray[courierIndex].isDisabled = roadMode
                }
                getInputFieldClone.otherDetails = currentSelectedArray
                setSetInputField(getInputFieldClone);
                setCallbackFunction("clearVehicleDet");
            }
                break;
            case "otherTransporterName": {
                if (item?.type == "text") {
                    let updatedData = { ...prevValue };
                    updatedData.otherTransporterName = { transporterName: val?.target?.value }
                    return updatedData
                }

            }
        }
    }

    const calculateFright = () => {
        let formDataClone = { ...formData }, errorDataClone = { ...errorData };
        let fright = Number(formData?.otherDetails?.lrWeight || 0) * Number(formData?.otherDetails?.lrRate || 0) + Number(formData?.otherDetails?.otherCharges || 0);
        if (!isNaN(fright)) fright = fright?.toFixed(2); // Freight value will only be upto two decimals.
        formDataClone.otherDetails = {
            ...formDataClone.otherDetails,
            lrFreight: fright || 0
        }
        if (errorDataClone?.["otherDetails"]?.["lrFreight"]) {
            delete errorDataClone?.["otherDetails"]?.["lrFreight"]
            setErrorData(errorDataClone);
        }
        setFormData(formDataClone);
    }

    const handleBlurFun = (key, val) => {
        switch (key) {
            case "lrWeight": case "otherTransporterName": {
                if (formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterName && formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterCode && formData?.otherDetails?.lrWeight && +(formData?.otherDetails?.lrWeight) != 0 && !isEdit) {
                    let payload = {
                        transporterCode: formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterCode || "",
                        transporterName: formData?.logisticsAndDeliveryDetails?.otherTransporterName?.transporterName || "",
                        stationFrom: formData?.otherDetails?.stationFrom || "",
                        stationTo: formData?.otherDetails?.stationTo || "",
                        lrBales: Number(formData?.otherDetails?.lrBales || 0) || 0,
                        lrWeight: formData?.otherDetails?.lrWeight || "",
                        lrPcs: formData?.otherDetails?.lrPcs || ""
                    }
                    // Call Api if lrRate is visible means it is displaying
                    const hasLrRate = getInputField?.otherDetails?.some(obj => obj.key === 'lrRate');
                    if(hasLrRate) {
                        dispatchHandler(dispatch, "vendorlogiLrGetRateRequest", payload, permissionsObj)
                    }
                }
            }
                break;
            case "lrRate": case "otherCharges": {
                calculateFright()
            }
                break;
        }
    }

    const disabledDate = (key, current) => {
        switch (key) {
            case "lrDate": return current && current > dayjs().endOf('day');
            case "lrETADate": {
                if (current && current < currentDate.startOf('day')) {
                    return true;
                }
                if (!isEdit && selectedData?.validToSelectionDate) {
                    const endDate = dayjs(selectedData?.validToSelectionDate)?.format("YYYY-MM-DD");
                    if (current && current?.isAfter(endDate)) {
                        return true;
                    }
                }
                return false;
            }
            case "invoiceDate": {
                if (current && current > currentDate.startOf('day')) {
                    return true;
                }
                return false;
            }
            default: return
        }
    }

    const getSuccessRes = (data, key) => {
        let fileDirectory = { ...uploadedFileDirectory };
        fileDirectory[key] = data?.fileDirectory
        setUploadedFileDirectory(fileDirectory)
    }

    const getInputProps = (key) => {
        let commonProps = {
            viewDataType: "table-view",
            modalMainClass: "use-as-generic-dropdown",
            search: {
                placeholder: `Search...`
            },
        };
        switch (key) {
            case "address": return ({
                ...commonProps,
                getListData: (response) => {
                    return response?.resource
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "vendFindAllAddress",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: "",
                            vendorCode : userType == "ENT" ? selectedData?.vendorCode || "" : undefined
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: permissionsObj
                },
                headerKeys: {
                    shortName: { value: "Short Name" },
                    email: { value: "Email" },
                    addressLine1: { value: "Address Line 1" },
                    address: { value: "Address Line 2" },
                    city: { value: "City" },
                    state: { value: "State" },
                    country: { value: "Country" },
                    zipCode: { value: "ZipCode" },
                    contactPerson: { value: "Contact Person" },
                    contactNumber: { value: "Contact Number" },
                },
                itemKeys: {
                    shortName: ["shortName"],
                    email: ["email"],
                    addressLine1: ["addressLine1"],
                    address: ["address"],
                    city: ["city"],
                    state: ["state"],
                    country: ["country"],
                    zipCode: ["zipCode"],
                    contactPerson: ["contactPerson"],
                    contactNumber: ["contactNumber"],
                }
            })
            case "lrType": return ({
                getListData: () => ([
                    { value: "To Pay", lrType: "topay" },
                    { value: "To Be Billed", lrType: "toBilled" },
                    { value: "Paid", lrType: "Paid" }
                ]),
                headerKeys: {
                    "value": { "label": "Type" }
                },
                itemKeys: {
                    "value": ["value"]
                }
            })
            case "transporterMode": return ({
                modalMainClass: '!min-h-[0]',
                getListData: () => transportModeDropdown || [],
                //      [
                //     { value: "By Road", transporterMode: "Road" },
                //     { value: "By Air", transporterMode: "Air" },
                //     { value: "By Rail", transporterMode: "Rail" },
                //     { value: "Courier", transporterMode: "By Courier" }
                // ]),
                headerKeys: {
                    "value": { "label": "Mode" }
                },
                itemKeys: {
                    "value": ["value"]
                }
            })
            case "vehicleType": return ({
                getListData: () => vehicleTypeList,
                headerKeys: {
                    "vehicleType": { "label": "Vehicle Type" }
                },
                itemKeys: {
                    "vehicleType": ["vehicleType"]
                }
            })
            case "consignmentSlip": return ({
                labelData: {
                    header: "Upload Consignment Slip",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                getResOutside: (data) => getSuccessRes(data, key),
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "CONSIGNMENT");
                        formData.append('requestId', uuId);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "ewbBillDoc": return ({
                labelData: {
                    header: "Upload E-Way Bill Doc",
                },
                deleteImgFromServer: deleteImgFromServer,
                getResOutside: (data) => getSuccessRes(data, key),
                updateImageState: updateImageState,
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "EWAY_BILL");
                        formData.append('requestId', uuId);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "invoiceDoc": return ({
                labelData: {
                    header: "Upload Invoice",
                },
                deleteImgFromServer: deleteImgFromServer,
                getResOutside: (data) => getSuccessRes(data, key),
                updateImageState: updateImageState,
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                maxFiles : 1,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            if(file?.name)
                                formData.append("file", file);
                        })
                        formData.append('documentId', storeAutoApiRes?.shipmentId)
                        formData.append('type', "INVOICE");
                        formData.append('requestId', uuId);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "otherTransporterName": return ({
                ...commonProps,
                getListData: (response) => {
                    return response?.resource
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "getAllTransporters",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            slCode: storeAutoApiRes?.consignorCode
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: permissionsObj,
                },
                headerKeys: {
                    transporterCode: { value: "Transporter/Courier Co. Code" },
                    transporterName: { value: "Transporter/Courier Co. Name" },
                },
                itemKeys: {
                    transporterCode: ["transporterCode"],
                    transporterName: ["transporterName"],
                },
            })
            case "getLrDetails": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown !top-[37px]",
                isListItemDisabled: (item) => item?.item?.shipmentAdviceCode == selectedData?.shipmentAdviceCode,
                getListData: (response) => response?.resource,
                api: {
                    reduxState: "generalStore",
                    apiName: "getTableComponentFifthList",
                    apiPayload: (params) => {
                        return {
                            type: 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: "",
                            apiUrl: "/purchase/logistics/get/all/lrprocessing",
                            baseUrl: CONFIG.SM_BACKEND_BASE_URL,
                            displayName: "ENT_LR_PROCESSING_ALL",
                            filter: {},
                            pageSize: 10,
                            status: "SHIPMENT_SHIPPED"
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "orders", "view")
                },
                headerKeys: {
                    shipmentAdviceCode: { value: "ASN Number" }
                },
                itemKeys: {
                    shipmentAdviceCode: ["shipmentAdviceCode"]
                },
            })
            default: return
        }
    }

    const deleteImgFromServer = (files) => {
        let payload = [];
        files?.map((file) => {
            let fileObj = {
                fileName: file?.fileName,
                filePath: file?.filePath,
                id: file?.id
            }
            payload.push(fileObj);
        });
        dispatchHandler(dispatch, "utilityDocumentDeleteRequest", payload, permissionsObj);
    }

    const updateLrDetails = (data) => {
        let formDataClone = { ...formData };
        let lrPcs = data.reduce((total, obj) => Number(obj.totalRequestedQty) + total, 0), lrBales = data.reduce((total, obj) => Number(obj.lrBales) + total, 0), declarationAmount = data.reduce((total, obj) => Number(obj.invoiceAmount) + total, 0);
        setLrDetailList(data);
        formDataClone.otherDetails = {
            ...formDataClone.otherDetails,
            lrPcs: lrPcs,
            lrBales: lrBales,
            declarationAmount: declarationAmount
        }
        setFormData(formDataClone);
    }

    const getParentChildProps = () => {
        let payload = {
            animationType: "top",
            postitionProps: { top: "0", margin: 0, left: "0", borderRadius: 0 },
            dimensions: { width: "100%", height: 450 },
            closeModal: () => setOpenedModal("")
        }
        switch (openedModal) {
            case "addAsn": {
                return {
                    ...payload,
                    selectedData: selectedData,
                    lrDetailList: lrDetailList,
                    formData: formData,
                    updateLrDetails: updateLrDetails,
                }
            }
            case "manageAddress": {
                return {
                    ...payload,
                    animationType: "bottom",
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: 5 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
					postitionProps: { position: 'relative' },
                    dimensions: { width: "80%", height: "70%", maxHeight: '590px', maxWidth: '1140px', borderRadius: 5  },
                    permissionObj : getPermissionKey("purchase", "logistic", isEdit ? "update" : "create"),
                }
            }
            case "confirmModal" : {
                return {
                    ...payload,
                    animationType: 'bottom',
                    parentModalOuterMostClassName: 'flex items-center justify-center',
					postitionProps: { position: 'relative' },
                    dimensions: { minWidth: "350px", minHeight: '150px', height: "fit-content", maxWidth: '450px', maxHeight: '600px', borderRadius: 5 },
                    label: "Clear form data ?",
                    subLabel: () => { return <LanguageTranslator tag='p'>Changing the ASN no. will clear the form data. Are you sure you want to proceed?</LanguageTranslator> },
                    secondaryBtnLabel: "Cancel",
                    closeModal: () => { setOpenedModal(false); setModalData(null) },
                    primaryBtnLabel: "Yes",
                    finalSubmit: () => handleChange("clearFormData")
                }
            }
            case "openImageViewModal": {

                let extName = getFileTypeFromUrl(modalData);
                let type = getFileNameFromExt(extName)

                return {
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    closeModal: () => setOpenedModal(false),
                    filesData:  [{
                        fileUrl: modalData || "",
                        fileType: type,
                    }]
                }
            }
        }
    }

    const getChildComponent = () => {
        switch (openedModal) {
            case "addAsn": return AddShipmentAdvice;
            case "manageAddress": return ManageAddress;
            case "confirmModal": return GenericDeleteModal;
            case "openImageViewModal": return GenericMediaViewModal;
            default: return <React.Fragment />
        }
    }

    const recommendNow = () => {
        if (formData?.logisticsAndDeliveryDetails?.address?.zipCode) {
            let payload = {
                orderId: selectedData?.orderId,
                logisticDraftNo: storeAutoApiRes?.logisticDraftNo || "",
                zipCode: formData?.logisticsAndDeliveryDetails?.address?.zipCode,
                shipmentId: selectedData?.shipmentId,
                shipmentAdviceCode: storeAutoApiRes?.shipmentAdviceCode || ""
            }
            dispatchHandler(dispatch, "vendorlogiRecommendationRequest", payload, permissionsObj)
        }
        else {
            customToast({ title: "Please fill Address field.", status: 'warning' })
        }
    }

    const renderEwayBillBottomComponent = () => {
        return (
            <label className="generic-checkbox" style={{ marginLeft: '15px' }} >
                <LanguageTranslator tag='span'>I hereby declare that the distance between station from and to is less than 50KM.</LanguageTranslator>
                <input type="checkBox" disabled={null} checked={ewayBillChecked} onChange={() => setEwayBillChecked(!ewayBillChecked)} />
                <span className={`checkmark1`}></span>
                <span className='generic-tooltip'>Other Transporter</span>
            </label>
        )
    }

    const getSummaryKeys = {
        shipmentRequestedQty: "ASN Qty",
        invoiceAmount: "Invoice Amount",
        // poAmount: "PO Amount",
        // poQty: "PO Qty",
    }

    return (
        <div className='create-lr-form'>
            <GenericFormSpreadTypeComponent
                spreadFormExtraClass={`${((COURIER_PARTNER && showRecommendtion) || isEdit) ? 'manage-spread-scroll' : ''}`}
                headerComponent={{
                    label: {
                        contentPrimary: modalHeading
                    },
                    rightComponent:
                        () => (
                            
                            <>
                                <div className='mhs-left'>
                                    <div className='mhsl-row !items-center'>
                                        {!isEdit && vendConfig?.LOGISTIC_ASN_MASKING?.toLowerCase() !== "true" && prevParams?.type != "CREATE_SHIPMENT_WITH_LR" && <GenericInput
                                            genInputExtraClass="!w-[175px] !m-0 !mr-3"
                                            gibInnerClassName="!border-[#A9A8A8]" 
                                            key="shipmentAdviceCode"
                                            value={selectedData?.shipmentAdviceCode}
                                            type={"dropdown"}
                                            inputProps={() => getInputProps("getLrDetails")}
                                            onChange={(data)=> handleChange('clearFormDataConfirm', data)}
                                            iconRight={
                                                <div className="border-l border-[#A9A8A8] flex items-center h-[31px] !-my-3 pl-2 ml-1">
                                                    <Icons.DownArrowNew />
                                                </div>
                                            }
                                        />}
                                        {
                                            !isEdit && vendConfig?.LOGISTIC_ASN_MASKING?.toLowerCase() === "true" && 
                                            <div className='ksmhl-col'>
                                                <LanguageTranslator tag='p' className='flex items-center gap-1'>ASN Number {userType === "VENDOR" && <span className='text-[11px] text-[#FE9D0B] rounded-[4px] bg-[#FE9D0B1A] px-[5px] py-[3px] flex items-center gap-1'><EyeOff size={11} color='#FE9D0B'/>Masked</span>}</LanguageTranslator>
                                                <h3>{userType === "VENDOR" ? selectedData?.asnMask || "-" : selectedData?.shipmentAdviceCode ?? "-"}</h3>
                                            </div>
                                        }
                                        <div className='ksmhl-col'>
                                            <LanguageTranslator tag='p'>Logistic Number</LanguageTranslator>
                                            <h3>{isEdit ? storeAutoApiRes?.logisticNo : storeAutoApiRes?.logisticDraftNo || "-"}</h3>
                                        </div>
                                        <div className='ksmhl-col'>
                                            <LanguageTranslator tag='p'>Today Date</LanguageTranslator>
                                            <h3>{dayjs(currentDate).format("YYYY-MM-DD") || "-"}</h3>
                                        </div>
                                        
                                    </div>
                                </div>
                            </>
                        ),
                    rowEndComponent: () => (!isEdit && <div className='mr-4 flex items-center gap-3'>
                                            {Object.keys(getSummaryKeys)?.map((key) => <div class="ksmhl-col px-2.5 py-2 rounded-[10px] bg-[#FAFAFA] flex items-center gap-5">
                                                    <div className='flex items-center'>
                                                        {key === 'shipmentRequestedQty' ? '' : <IndianRupee size={15} />}
                                                        <h3 className='mb-0 text-base font-semibold text-fontBlack'>{selectedData?.[key]}</h3>
                                                    </div>
                                                    <div className='flex items-center gap-1.5'>
                                                        <p className='mb-0 text-[11px] font-normal text-[#4A5D7A]'>{getSummaryKeys?.[key]}</p>
                                                        <div className={`p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center ${key === 'shipmentRequestedQty' ? 'bg-[#ECB80B]' : 'bg-[#5D5FEF]'}`}>{key === 'shipmentRequestedQty' ? <FileOutput size={17} strokeWidth={1.5} color='white' /> : <HandCoins size={17} strokeWidth={1.5} color='white' />}</div>                        
                                                    </div>
                                                </div>
                                            )}
                                        </div>),
                    closeModal: props.closeModal
                }}
                renderCustomItems={{
                    0: () => {
                        return (
                            <>
                                {COURIER_PARTNER && !isEdit && showRecommendtion && <div className="recomandation-strip">
                                    <span className='clrmbf-text'>Get Transportation Recommendation </span>
                                    <button type='button' className='clrmbf-button flex' onClick={() => recommendNow()}>Recommend Now
                                        <span className='clrmbf-icon'><Icons.RightArrowWhite /></span>
                                    </button>
                                </div>}
                                {isEdit &&
                                    <div className="p-lr-15">
                                        <div className='lrid-innder flex'>
                                            <Icons.InfoYellow />
                                            <LanguageTranslator tag='p'>Changing ETA date will reschedule appointment date for the created LR.</LanguageTranslator>
                                        </div>
                                    </div>
                                }
                            </>
                        )
                    }
                }}
                inputSections={{
                    logisticsAndDeliveryDetails: {
                        label: "Logistics & Delivery Details",
                        inputFields: () => getInputFields("logisticsAndDeliveryDetails"),
                    },
                    eWayBillDoc: getInputFields("eWayBillDoc")?.length ? {
                        label: "E-Way Bill Details",
                        inputFields: () => getInputFields("eWayBillDoc"),
                        bottomComponent: getInputField?.['otherDetails']?.find(item => item?.key == 'distance') !== undefined ? renderEwayBillBottomComponent() : null
                    } : null,
                    otherDetails: {
                        label: "Courier & Transport Details",
                        inputFields: () => getInputFields("otherDetails"),
                    }
                }}
                finalSubmitButton={isEdit ? "Update Request" : "Create Request"}
                availableDocument={props.availableDocument || null}
                inputState={formData}
                updateInputState={setFormData}
                errorState={errorData}
                finalButtonDisabled={() => {
                    return (digiVendStore?.vendorlogiLrCreateData?.isLoading || digiVendStore?.updateLogisticsData?.isLoading)
                }}
                clearDataButtonNotRequired={true}
                updateErrorState={setErrorData}
                finalSubmit={(data) => handleChange("finalSubmit", data)}
                extraButtonWithSubmit={(isEdit || userType === "ENT" || vendConfig?.isCreateMultipleASNReq?.toLowerCase() !== "true") ? null :
                    { label: "Add ASN", type: "default", onClick: () => handleChange("addAsn"), disable: vendConfig?.isCreateMultipleASNReq?.toLowerCase() !== "true", rightIcon: vendConfig?.isCreateMultipleASNReq?.toLowerCase() !== "true" ? <span className="generic-tooltip">Multiple ASNs not allowed</span> : false }
                }
            />
            {openedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => setOpenedModal(false)}
            />}
        </div>
    )
}

export default CreateLr